module.exports = __webpack_public_path__ + "img/nota-codigo-ahued.c9c20ed1.png";